import React, { Component } from "react";
import { withRouter } from 'react-router-dom';

import UI from "../../../actions/ui-helper";
import API from "../../../actions/api-helper";
import Util from "../../../actions/util.js";

import ConsultaProcedimentoResultado from "./ConsultaProcedimentoResultado";

class ConsultaProcedimento extends Component {
  constructor(props) {
    super(props);
    this.state = {
      consulta: {
        usuarioId: 0,
        codigo: "",
        descricao: ""
      },
      usuarios: [],
      resultado: []
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillMount() {
    UI.loader("show", "Aguarde, buscando profissionais...");
    API.get("/usuarios/ativos").then(
      (json) => {
        // Cria uma lista simplificada de usuários
        let usuarios = [{ id: 0, nome: "TODOS" }];
        json.data.forEach(usuario => {
          usuarios.push({
            id: usuario.id,
            nome: usuario.nome
          });
        });
        this.setState({ usuarios: usuarios });
        UI.loader("hide");
      });
  }

  handleSubmit(event) {
    event.preventDefault();
    let data = this.state.consulta;

    UI.loader("show", "Um momento...");
    API.post("/procedimentos/consulta", data)
      .then(
        function (json) {
          this.setState({ resultado: json.data });
          UI.loader("hide");
        }.bind(this)
      )
      .catch(function (json) {
        UI.alert(false, json.message);
        UI.loader("hide");
      });
  }

  handleChange(event) {
    let consulta = this.state.consulta;
    consulta[event.target.name] = event.target.value;

    this.setState({ consulta: consulta });
  }

  exportarCSV() {
    if (!Util.exportarProcedimentosCSV(this.state.resultado)) {
      UI.alert(false, "Não há nenhum resultado para ser exportado.");
    }
  }

  render() {
    return (
      <form
        className="form-sample"
        autoComplete="off"
        spellCheck="false"
        onSubmit={this.handleSubmit}
      >
        <div className="row">
          <div className="col-12 grid-margin">
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-6">
                    <h4 className="card-title">CONSULTA PROCEDIMENTO</h4>
                  </div>
                  <div className="col-md-6 text-right">
                    <button
                      onClick={() => { this.props.history.push("/procedimento/cadastro"); }}
                      className="btn btn-rounded btn-icons btn-outline-success"
                      type="button">
                      <i className="fa fa-plus"></i>
                    </button>
                  </div>
                </div>
                <p className="card-description" />
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group row">
                      <div className="col-sm-3">
                        <label>Profissional Vinculado</label>
                        <select
                          name="usuarioId"
                          className="form-control"
                          value={this.state.usuarioId}
                          onChange={this.handleChange}
                        >
                          {this.state.usuarios.map(
                            function (usuario, i) {
                              return (
                                <option key={usuario.id} value={usuario.id}>
                                  {usuario.nome}
                                </option>
                              );
                            }
                          )}
                        </select>
                      </div>
                      <div className="col-sm-3">
                        <label>Código</label>
                        <input
                          autoFocus
                          placeholder="CÓDIGO"
                          name="codigo"
                          type="text"
                          className="form-control"
                          value={this.state.consulta.codigo}
                          onChange={this.handleChange}
                        />
                      </div>
                      <div className="col-sm-6">
                        <label>Descrição</label>
                        <input
                          autoFocus
                          placeholder="DESCRIÇÃO"
                          name="descricao"
                          type="text"
                          className="form-control"
                          value={this.state.consulta.descricao}
                          onChange={this.handleChange}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12 text-right">
                        <button
                          type="button"
                          className="btn btn-sm btn-success mb-2"
                          onClick={() => this.exportarCSV()}
                        >
                          <i className="fa fa-download"></i>&nbsp;
                            Exportar CSV
                        </button>
                        &nbsp;
                        <button
                          type="submit"
                          className="btn btn-sm btn-primary mb-2"
                        >
                          <i className="fa fa-search"></i>&nbsp;
                            Pesquisar
                        </button>
                      </div>
                    </div>
                    <ConsultaProcedimentoResultado resultado={this.state.resultado} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    );
  }
}

export default withRouter(ConsultaProcedimento);
